// extracted by mini-css-extract-plugin
export default {"catCard":"CategoryCard_catCard__KhxD5","categoryImage":"CategoryCard_categoryImage__hmj9i","categoryOverlay":"CategoryCard_categoryOverlay__-6hoL"};